import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("bp-scripture-link")
export class ScriptureLink extends LitElement {
  static styles = css`
    :host {
      display: inline-block;
    }

    button {
      font: var(--font-sans);
      border: unset;
      background: unset;
      padding: unset;
      font-size: inherit;
      color: inherit;
      cursor: pointer;
      text-align: inherit;
      line-height: inherit;
      text-decoration: underline;
    }
  `;

  @property()
  reference?: string;

  handleClick(e: MouseEvent) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("bp:scripture_link", {
        detail: { reference: this.reference },
      }),
    );
  }

  render() {
    return html` <button @click="${this.handleClick}"><slot></slot></button> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-scripture-link": ScriptureLink;
  }
}
